<template>
  <div class="home">
    <div class="flex-item_right">
      <h3 class="description">
        This website hosts data of the UK MRC AML genomic study PMID
        <a href="https://pubmed.ncbi.nlm.nih.gov/35941135" target="_blank">
          35941135
        </a>
        .
      </h3>

      <sui-grid :columns="1" divided="vertically">
        <sui-grid-row :columns="1">
          <sui-grid-column>
            <router-link to="calculator">
              <div class="home-resources">
                AML Classification and Risk Stratification Calculator
              </div>
            </router-link>
          </sui-grid-column>
        </sui-grid-row>
        <sui-grid-row :columns="3">
          <sui-grid-column>
            <a
              target="_blank"
              href="https://www.cbioportal.org/study/summary?id=laml_tcga_pub"
            >
              <div class="home-resources">
                cBioPortal
              </div>
            </a>
          </sui-grid-column>
          <sui-grid-column>
            <router-link to="supplementary">
              <div class="home-resources">
                Biomarker Info
              </div>
            </router-link>
          </sui-grid-column>
          <sui-grid-column>
            <router-link to="gene-panel">
              <div class="home-resources">
                AML Gene Panel
              </div>
            </router-link>
          </sui-grid-column>
        </sui-grid-row>
      </sui-grid>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  mounted() {
    window.analytics.page("Home");
  }
};
</script>

<style lang="scss">
.home {
  max-width: 900px;
  margin: auto;
}
.home .description {
  text-align: center;
  font-size: 16px;
  font-weight: 100;
  margin: 60px;
}
.home-resources {
  background: #f6f9ff;
  border: 1px solid #edeffa;
  border-radius: 4px;
  color: #00113d;
  font-family: DM Sans;
  font-size: 22px;
  padding: 16px;
  margin: 0px;
  text-align: center;
  font-weight: 500;
  height: 100px;
  padding-top: 40px;
}
</style>
